import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useHost } from 'contexts/Host';
import { getIFrame, getPartnerCoreIFrame } from 'utils/browserUtil';
import { ClmPortalOutgoingPostMessageTypes } from 'utils/postMessageUtil';
import { selectIsDebugInfoOn } from 'selectors/debugInfoSelector';
import { isNotNullOrUndefined } from 'utils/utils';

export const usePostMessageToIFrame = () => {
  const isDebugInfoOn: boolean = useSelector(selectIsDebugInfoOn);
  const { shadowRoot } = useHost();

  const postMessageToIFrame = useCallback(
    (message: any, iFrame?: HTMLIFrameElement) => {
      if (isDebugInfoOn) {
        // eslint-disable-next-line no-console
        console.log('PORTAL Sent:', message);
      }
      iFrame?.contentWindow?.postMessage(message, '*');
    },
    [isDebugInfoOn],
  );

  const postMessageToIFrameByType = useCallback(
    (messageType: ClmPortalOutgoingPostMessageTypes, value?: unknown) => {
      const messagePayload: Record<string, unknown> = { message: messageType };

      if (isNotNullOrUndefined(value)) {
        messagePayload.value = value;
      }
      postMessageToIFrame(messagePayload, getIFrame(shadowRoot));
    },
    [postMessageToIFrame, shadowRoot],
  );

  const postSetPartnerProfileMessage = useCallback(
    (partnerProfile: string) => {
      postMessageToIFrame(
        {
          message: ClmPortalOutgoingPostMessageTypes.SET_PARTNER_PROFILE,
          value: partnerProfile,
        },
        getPartnerCoreIFrame(),
      );
    },
    [postMessageToIFrame],
  );

  return {
    postMessageToIFrame,
    postMessageToIFrameByType,
    postSetPartnerProfileMessage,
  } as const;
};
